import React from 'react'
import {Spinner} from 'react-bootstrap'

export const PageSpinner = () => {
    return <div className='d-flex justify-content-center my-5'>    
                <Spinner animation="border" role="status" variant="primary">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
}